export const OFileTypeNames = {
  ACCDB: 'Microsoft Access Database',
  CSV: 'Comma Separated Values File',
  DOC: 'Microsoft Word Document',
  EXCEL: 'Microsoft Excel',
  GIF: 'GIF File',
  JPEG: 'JPEG File',
  MP4: 'MP4 File',
  PDF: 'Adobe Acrobat Document',
  PNG: 'PNG File',
  PPT: 'Microsoft Powerpoint',
  RTF: 'Rich Text Format',
  SVG: 'SVG File',
  TEXT: 'Text Document',
  ZIP: 'Compressed (zipped) folder',
} as const
export type TFileTypeName = (typeof OFileTypeNames)[keyof typeof OFileTypeNames]

export type IAppAcceptableFileTypes =
  | 'accdb'
  | 'csv'
  | 'doc'
  | 'docx'
  | 'gif'
  | 'jpeg'
  | 'jpg'
  | 'mdb'
  | 'mp4'
  | 'pdf'
  | 'ppt'
  | 'pptx'
  | 'png'
  | 'rtf'
  | 'svg'
  | 'txt'
  | 'xls'
  | 'xlsx'
  | 'xiv'
  | 'zip'

export type TFilename<T extends string> = `${string}.${T}`
export type TFilesWithIcons = 'excel' | 'pdf' | 'mov' | 'generic'

export interface IResourceLibraryIconMap {
  [key: string]: string
}
